/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetMeResp } from './GetMeResp';
import {
    GetMeRespFromJSON,
    GetMeRespFromJSONTyped,
    GetMeRespToJSON,
} from './GetMeResp';

/**
 * 
 * @export
 * @interface GetMe200ResponseAllOf
 */
export interface GetMe200ResponseAllOf {
    /**
     * 
     * @type {GetMeResp}
     * @memberof GetMe200ResponseAllOf
     */
    result: GetMeResp;
}

/**
 * Check if a given object implements the GetMe200ResponseAllOf interface.
 */
export function instanceOfGetMe200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function GetMe200ResponseAllOfFromJSON(json: any): GetMe200ResponseAllOf {
    return GetMe200ResponseAllOfFromJSONTyped(json, false);
}

export function GetMe200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMe200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': GetMeRespFromJSON(json['result']),
    };
}

export function GetMe200ResponseAllOfToJSON(value?: GetMe200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': GetMeRespToJSON(value.result),
    };
}

